import { Card, Col, Modal, Nav, Row, Tab } from "react-bootstrap";

export default function SsrInfo({ show, handleClose, ssrInfo }) {
  return (
    <div>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Seat,Meal,Extra Baggage & Others Service
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div>{JSON.stringify(console.log(ssrInfo))}</div> */}
          <Tab.Container id="left-tabs-example" defaultActiveKey="seat">
            <Row>
              <Col sm={3}>
                <Nav variant="pills" className="flex-column">
                  <Nav.Item>
                    <Nav.Link eventKey="seat">Seat Info</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="meal">Meal Info</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="bag">Extra Baggage Info</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="extraServices">
                      Extra Services Info
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="fastForward">
                      Fast Forward Info
                    </Nav.Link>
                  </Nav.Item>
                  {ssrInfo?.ssrWheelchair && (
                    <Nav.Item>
                      <Nav.Link eventKey="wheelchair">Wheelchair Info</Nav.Link>
                    </Nav.Item>
                  )}
                  {/* //Frequent */}
                  {ssrInfo?.ff && (
                    <Nav.Item>
                      <Nav.Link eventKey="FrequentFlyer">
                        Frequent Flyer
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </Nav>
              </Col>
              <Col sm={9}>
                <Tab.Content>
                  <Tab.Pane eventKey="seat">
                    <Row>
                      {ssrInfo?.ssrSeatInfos &&
                      Object.keys(ssrInfo.ssrSeatInfos).length > 0 ? (
                        Object.entries(ssrInfo?.ssrSeatInfos).map(
                          ([key, { code, amount }], index) => (
                            <Col key={index}>
                              <Card>
                                <Card.Body>
                                  <Card.Title>
                                    <div
                                      style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        borderBottom: "1px solid #984ee1",
                                      }}
                                    >
                                      {key}
                                    </div>
                                  </Card.Title>
                                  <Card.Text>
                                    <strong>Seat No:</strong> {code}
                                  </Card.Text>
                                  <Card.Text>
                                    <strong>Amount:</strong> ₹{" "}
                                    {Number(amount).toFixed(2)}
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </Col>
                          ),
                        )
                      ) : (
                        <div>No Seat info available</div>
                      )}
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey="meal">
                    <Row>
                      {ssrInfo?.ssrMealInfos &&
                      Object.keys(ssrInfo.ssrMealInfos).length > 0 ? (
                        Object.entries(ssrInfo?.ssrMealInfos).map(
                          ([key, { code, desc, amount }], index) => (
                            <Col key={index}>
                              <Card>
                                <Card.Body>
                                  <Card.Title>
                                    <div
                                      style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        borderBottom: "1px solid #984ee1",
                                      }}
                                    >
                                      {key}
                                    </div>
                                  </Card.Title>
                                  <Card.Text>
                                    <strong>Meal code:</strong> {code}
                                  </Card.Text>
                                  <Card.Text>
                                    <strong>Amount:</strong> ₹{" "}
                                    {Number(amount).toFixed(2)}
                                  </Card.Text>
                                  <Card.Text>
                                    <Col>{desc}</Col>
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </Col>
                          ),
                        )
                      ) : (
                        <div>No Meal info available</div>
                      )}
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey="bag">
                    <Row>
                      {ssrInfo?.ssrBaggageInfos &&
                      Object.keys(ssrInfo?.ssrBaggageInfos).length > 0 ? (
                        Object.entries(ssrInfo?.ssrBaggageInfos).map(
                          ([key, { code, desc, amount }], index) => (
                            <Col key={index}>
                              <Card>
                                <Card.Body>
                                  <Card.Title>
                                    <div
                                      style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        borderBottom: "1px solid #984ee1",
                                      }}
                                    >
                                      {key}
                                    </div>
                                  </Card.Title>
                                  <Card.Text>
                                    <strong>Baggage code:</strong> {code}
                                  </Card.Text>
                                  <Card.Text>
                                    <strong>Amount:</strong> ₹{" "}
                                    {Number(amount).toFixed(2)}
                                  </Card.Text>
                                  <Card.Text>
                                    <Col>{desc}</Col>
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </Col>
                          ),
                        )
                      ) : (
                        <div>No extra Baggage info available</div>
                      )}
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey="extraServices">
                    <Row>
                      {ssrInfo?.ssrExtraServiceInfos &&
                      Object.keys(ssrInfo.ssrExtraServiceInfos).length > 0 ? (
                        Object.entries(ssrInfo?.ssrExtraServiceInfos).map(
                          ([key, { code, desc, amount }], index) => (
                            <Col key={index}>
                              <Card>
                                <Card.Body>
                                  <Card.Title>
                                    <div
                                      style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        borderBottom: "1px solid #984ee1",
                                      }}
                                    >
                                      {key}
                                    </div>
                                  </Card.Title>
                                  <Card.Text>
                                    <strong>Extra Service code:</strong> {code}
                                  </Card.Text>
                                  <Card.Text>
                                    <strong>Amount:</strong> ₹{" "}
                                    {Number(amount).toFixed(2)}
                                  </Card.Text>
                                  <Card.Text>
                                    <Col>{desc}</Col>
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </Col>
                          ),
                        )
                      ) : (
                        <div>No extra service info available</div>
                      )}
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey="fastForward">
                    <Row>
                      {ssrInfo?.ssrFastForwardInfos &&
                      Object.keys(ssrInfo.ssrFastForwardInfos).length > 0 ? (
                        Object.entries(ssrInfo?.ssrFastForwardInfos).map(
                          ([key, { code, desc, amount }], index) => (
                            <Col key={index}>
                              <Card>
                                <Card.Body>
                                  <Card.Title>
                                    <div
                                      style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        borderBottom: "1px solid #984ee1",
                                      }}
                                    >
                                      {key}
                                    </div>
                                  </Card.Title>
                                  <Card.Text>
                                    <strong>Fast Forward code:</strong> {code}
                                  </Card.Text>
                                  <Card.Text>
                                    <strong>Amount:</strong> ₹{" "}
                                    {Number(amount).toFixed(2)}
                                  </Card.Text>
                                  <Card.Text>
                                    <Col>{desc}</Col>
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </Col>
                          ),
                        )
                      ) : (
                        <div>No Fast Forward info available</div>
                      )}
                    </Row>
                  </Tab.Pane>
                  {ssrInfo?.ssrWheelchair && (
                    <Tab.Pane eventKey="wheelchair">
                      <Row>
                        <Col>{ssrInfo?.ssrWheelchair ? "YES" : "NO"}</Col>
                      </Row>
                    </Tab.Pane>
                  )}
                  {ssrInfo?.ff && (
                    <Tab.Pane eventKey="FrequentFlyer">
                      <Row>
                        {Object.entries(ssrInfo?.ff || {}).map(
                          ([key, number, index]) => (
                            <Col key={index}>
                              <Card>
                                <Card.Body>
                                  <Card.Title>
                                    <div
                                      style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        borderBottom: "1px solid #984ee1",
                                      }}
                                    >
                                      {key}
                                    </div>
                                  </Card.Title>
                                  <Card.Text>
                                    <strong>Frequent Flyer Number:</strong>{" "}
                                    {number}
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </Col>
                          ),
                        )}
                      </Row>
                    </Tab.Pane>
                  )}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Modal.Body>
      </Modal>
    </div>
  );
}
